import { render, staticRenderFns } from "./CallNotification.vue?vue&type=template&id=3264d16e&scoped=true"
import script from "./CallNotification.vue?vue&type=script&lang=js"
export * from "./CallNotification.vue?vue&type=script&lang=js"
import style0 from "./CallNotification.vue?vue&type=style&index=0&id=3264d16e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3264d16e",
  null
  
)

export default component.exports